import { render, staticRenderFns } from "./AulasPresenciais.vue?vue&type=template&id=a2cd7970&scoped=true"
import script from "./AulasPresenciais.vue?vue&type=script&lang=js"
export * from "./AulasPresenciais.vue?vue&type=script&lang=js"
import style0 from "./AulasPresenciais.vue?vue&type=style&index=0&id=a2cd7970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cd7970",
  null
  
)

export default component.exports